import Vue from 'vue'
import store from '../cart-grid/@store'
import '../mini-cart/mini-cart.vue'

export default el => new Vue({
  name: 'Mini Cart',
  el,
  store
})
